import { gql } from '@apollo/client';

export const GET_LINK_TOKEN = gql`
mutation generatePlaidLink {
  generatePlaidLink {
    status
    data
    error
  }
}
`;

export const GET_ACCESS_TOKEN = gql`
mutation plaidGetAccessToken($plaidData : PlaidLinkData!) {
  plaidGetAccessToken(plaidData: $plaidData) {
    status
    error
    token
    dt
  }
}
`;
